export default "__VITE_ASSET__Cv1PS40u__"